const status = (response) => {
  if (response.ok) {
    return response;
  } else {
    let error = new Error(response.statusText || response.status);
    error.response = response;
    throw error;
  }
};

export default status;
